import { worldConfig } from '../../..';
import { getPOIFrom } from '../../utils';
import eventBus from '../../utils/emitter-event-bus';
import { Autosave } from '../autosave/autosave';
import { Builder } from '../builder/builder';
import { CarryHud } from '../carry/carry-hud';
import { CoinsHud } from '../coins/coins-hud';
import { Intro } from '../intro/intro';
import { Inventory } from '../inventory/inventory';
import { InventoryUI } from '../inventory/inventory-ui';
import { AutosaveInventoryRepository } from '../inventory/inventory-repository';
import { JoystickIntegrated } from '../joystick/joystick-integrated';
import { MerchantStock } from '../merchant/merchant-stock';
import { MerchantUI } from '../merchant/merchant-ui';
import { Narrator } from '../narrator/narrator';
import { Navigator } from '../navigator/navigator';
import { Spotlight } from '../spotlight/spotlight';
import { WorldEventBus } from './world.model';

export class WorldInstance {
  constructor() {
    const autosave = Autosave.getInstance();
    const inventory = Inventory.init(new AutosaveInventoryRepository(autosave));

    new Navigator();
    new Spotlight();
    new JoystickIntegrated();
    new Narrator();
    // Builder is an authoring tool, not part of the game. It is only included
    // when started via `npm run builder` (sets BUILDER=true); Parcel inlines the
    // env var at build time, so the default build dead-code-eliminates it.
    if (process.env.BUILDER === 'true') {
      new Builder();
    }
    new InventoryUI(inventory);
    new CoinsHud(inventory);
    new CarryHud(inventory);
    new MerchantUI(inventory, new MerchantStock());
    new Intro();

    const starterPOI = worldConfig.startingPOI;
    const autoSaveCurrentPOI = autosave.currentPOI;
    // Fall back to starter if autosaved POI no longer exists
    const currentPOI = autoSaveCurrentPOI && getPOIFrom(autoSaveCurrentPOI) ? autoSaveCurrentPOI : starterPOI;

    eventBus.emit(WorldEventBus.initialise, currentPOI);
  }
}
